import React, { useState } from 'react';
import Sidebar from './Sidebar';
import './Statistics.css';

const Statistics = ({ isVisible, onBack, onLogout, onNavClick }) => {
  const [selectedPeriod, setSelectedPeriod] = useState('week');

  if (!isVisible) return null;

  // Dữ liệu giả lập cho biểu đồ
  const weekData = [
    { day: 'M', value: 8 },
    { day: 'T', value: 12 },
    { day: 'W', value: 16 },
    { day: 'T', value: 10 },
    { day: 'F', value: 14 },
    { day: 'S', value: 18 },
    { day: 'S', value: 12 },
  ];

  const chartHeight = 150;
  const chartWidth = 600;
  const maxValue = 25;

  // Tạo đường line cho chart
  const points = weekData.map((item, index) => {
    const x = (index * (chartWidth / (weekData.length - 1)));
    const y = chartHeight - (item.value / maxValue) * chartHeight;
    return `${x},${y}`;
  }).join(' ');

  // Tạo area fill (đóng kín đường bao phía dưới)
  const fillPoints = `0,${chartHeight} ${points} ${chartWidth},${chartHeight}`;

  const rooms = [
    { id: 1, name: 'Living Room', icon: '🛋️', devices: 4, power: '20 kW' },
    { id: 2, name: 'Bedroom', icon: '🛏️', devices: 4, power: '20 kW' },
    { id: 3, name: 'Bathroom', icon: '🛁', devices: 4, power: '20 kW' },
    { id: 4, name: 'Kitchen', icon: '🍳', devices: 4, power: '20 kW' },
  ];

  const periods = ['Today', 'Week', 'Month', 'Year', 'Quarter'];

  return (
    <div className="dashboard-container">
      <Sidebar activeId="stats" onLogout={onLogout} onNavClick={onNavClick} />

      <div className="main-content stats-content">
        
        {/* Phần Layout Trên: Header | Menu Dọc | Chart & Cards */}
        <div className="stats-top-section">
          
          {/* Cột 1: Tiêu đề */}
          <div className="stats-header-col">
            <div className="stats-header-nav">
              <button className="stats-back-btn" onClick={onBack}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
              </button>
              <span className="stats-subtitle">Statistics</span>
            </div>
            <h1 className="stats-title">Electricity<br />Usage</h1>
          </div>

          {/* Cột 2: Menu chọn thời gian (Dọc) */}
          <div className="stats-period-col">
            {periods.map((period) => (
              <button
                key={period}
                className={`stats-period-btn ${selectedPeriod === period.toLowerCase() ? 'active' : ''}`}
                onClick={() => setSelectedPeriod(period.toLowerCase())}
              >
                {period}
              </button>
            ))}
          </div>

          {/* Cột 3: Cards & Chart */}
          <div className="stats-visuals-col">
            
            {/* Hàng Card thông số */}
            <div className="stats-summary-row">
              <div className="stats-summary-card">
                <div className="stats-summary-label">This Week</div>
                <div className="stats-summary-value">50 kW</div>
                <div className="stats-summary-change positive">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>
                  +7.45%
                </div>
              </div>
              
              <div className="stats-summary-card">
                <div className="stats-summary-label">Total Loss</div>
                <div className="stats-summary-value">30.2 kW</div>
                <div className="stats-summary-change negative">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                  -3.35%
                </div>
              </div>
            </div>

            {/* Khu vực Chart */}
            <div className="stats-chart-container">
              <svg width="100%" height="100%" viewBox={`0 0 ${chartWidth} ${chartHeight}`} preserveAspectRatio="none">
                <defs>
                  <linearGradient id="chartGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.2"/>
                    <stop offset="100%" stopColor="#3b82f6" stopOpacity="0"/>
                  </linearGradient>
                </defs>
                
                {/* Vùng màu nền dưới chart */}
                <polygon points={fillPoints} fill="url(#chartGradient)" />
                
                {/* Đường line chart */}
                <polyline 
                  points={points} 
                  fill="none" 
                  stroke="#3b82f6" 
                  strokeWidth="4" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Phần Layout Dưới: Rooms List */}
        <div className="stats-rooms-section">
          <div className="stats-rooms-header">
            <h2 className="stats-rooms-title">Your Rooms</h2>
            <span className="stats-rooms-badge">{rooms.length}</span>
          </div>

          <div className="stats-rooms-scroll">
            {rooms.map((room) => (
              <div key={room.id} className="stats-room-card">
                <div className="stats-room-icon-box">
                  {room.icon}
                </div>
                <div className="stats-room-info">
                  <h3>{room.name}</h3>
                  <p className="stats-room-devices">• {room.devices} devices</p>
                  <p className="stats-room-power">{room.power}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Statistics;